import React, { memo } from 'react';
import { usePathname } from 'next/navigation';

import { IButton, ITypo } from '@/app/_components/common';
import { Wrapper } from '@/app/_components/layout';
import NavMobile from '@/app/_components/layout/Header/NavMobile';
import { Logo } from '@/app/assets/Icons';
import BurgerIcon from '@/app/assets/Icons/BurgerIcon';
import { HEADER_NAV_ITEMS, ROUTERS } from '@/constants';
import { map } from '@/utils';
import { cn, Link, useDisclosure } from '@nextui-org/react';

import MegaNav from './MegaNav';
import NavItem from './NavItem';

interface IProps extends React.HTMLProps<HTMLElement> {
	isScrolled: boolean;
}

const Navbar: React.FC<IProps> = ({ ref, isScrolled }) => {
	const pathname = usePathname();
	const { isOpen, onOpenChange } = useDisclosure();

	return (
		<Wrapper className="relative">
			<nav ref={ref}>
				<div className="row-between">
					<Link href={ROUTERS.HOME} className="z-10">
						<Logo
							className={cn('text-bittersweet', {
								'text-white': isScrolled,
							})}
						/>
					</Link>

					<IButton
						onClick={onOpenChange}
						variant="transparent"
						isIconOnly
						className="h-6 min-h-6 w-6 !p-0 lg:hidden"
					>
						<BurgerIcon
							className={cn(
								'text-gray relative h-6 w-6 shrink-0',
								{
									'text-white': isScrolled,
								}
							)}
						/>
					</IButton>

					<IButton
						className="z-10 hidden min-h-12 lg:inline-flex"
						variant={isScrolled ? 'bordered' : 'default'}
					>
						<ITypo size={16} weight="semi" className="uppercase">
							TẢI APP NGAY
						</ITypo>
					</IButton>

					<ul
						className={cn(
							'lg:row lg:center relative hidden lg:absolute lg:inset-x-0 lg:flex'
						)}
					>
						{map(HEADER_NAV_ITEMS, (item, idx) => {
							const isActive =
								item.href === pathname ||
								item.subHref === pathname;
							return (
								<div className="group" key={idx}>
									<NavItem
										{...item}
										isScrolled={isScrolled}
										isActive={isActive}
									/>
									{item.hasMegaNav && <MegaNav item={item} />}
								</div>
							);
						})}
					</ul>
				</div>

				<NavMobile
					isScrolled={isScrolled}
					isOpen={isOpen}
					onOpenChange={onOpenChange}
					pathname={pathname}
				/>
			</nav>
		</Wrapper>
	);
};

export default memo(Navbar);
